/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import Button from 'components/base/Button';
import SelectionProduct from './modals/SelectionProduct';
import '../styles.scss';

interface FilterProps {
  refetchInventoryItem?: any;
  tableData?: any;
  setTableData?: any;
}

const customModalStyles = {
  '.oven-modal .modal-dialog': {
    maxWidth: '600px', // Example width for "oven modal size"
    width: '90%' // Responsive width
  }
};

const Filter = ({
  refetchInventoryItem,
  tableData,
  setTableData
}: FilterProps) => {
  const { t } = useTranslation();

  const [openProduct, setOpenProduct] = useState(false);

  return (
    <>
      {/* prettier-ignore */ }
      <style>{`
        ${Object.entries(customModalStyles)
          .map(
            ([key, value]) =>
              `${key} { ${Object.entries(value)
                .map(([k, v]) => `${k}: ${v};`)
                .join(' ')} }`
          )
          .join(' ')}
      `}</style>
      <Form.Group
        className={'d-flex justify-content-between align-items-center'}
      >
        <h2>{t('new')}</h2>

        <div className="d-flex justify-content-between gap-2">
          <Button
            className="d-flex align-items-center gap-2"
            style={{ height: '48px' }}
            variant="primary"
            onClick={() => setOpenProduct(true)}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            {t('add')}
          </Button>
        </div>
      </Form.Group>
      <Modal
        show={openProduct}
        onHide={() => {
          setOpenProduct(false);
          refetchInventoryItem();
        }}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="oven-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '24px', fontWeight: '600' }}>
            {t('select_product')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SelectionProduct tableData={tableData} setTableData={setTableData} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Filter;
